export const environment = {
  API_URL: 'https://kma-api-dev.solcre.dev',
  // API_URL: 'http://localhost:8087',
  API: {
    OAUTH_URI: '/api/auth/login',
    OAUTH_REFRESH_URI: '/api/auth/token/refresh',
    VESSELS_URI: '/api/vessels',
    QUOTES_URI: '/api/quotes',
    PORTS_URI: '/api/ports',
    PORT_TARIFFS_URI: '/api/ports/:id/tariffs',
    PORT_TARIFFS_COLLECTION_URI: '/api/port-tariffs',
    PORT_TARIFF_LINES_URI: '/api/port-tariff-lines',
    PORT_TARIFF_LINE_REORDER_URI: '/api/port-tariff-lines/reorder',
    PORT_OVERTIME_RULES_URI: '/api/port_overtime_rules',
    PORT_CALL_COSTS_URI: '/api/port-calls/:id/costs',
    PORT_CALL_COST_ITEM_URI: '/api/port_call_costs',
    VOYAGES_URI: '/api/voyages',
    VOYAGES_PORTCALL_URI: '/api/voyages/:id/port-calls',
    VOYAGES_SUMMARY_URI: '/api/voyages/:id/summary',
    VOYAGES_PORTCALL_DETAILS_URI: '/api/port-calls/:id/details',
    CLIENTS_URI: '/api/clients',
    CLIENTS_VIEW_URI: '/api/clients/:id',
    CLIENTS_CONTACTS_URI: '/api/clients/:id/contacts',
    CLIENTS_QUOTES_URI: '/api/clients/:id/quotes',
    CLIENTS_RATES_URI: '/api/clients/:id/rates',
    CLIENT_RATES_URI: '/api/client_rates',
    CLIENT_RATES_MATCH_URI: '/api/client_rates/match',
    CURRENCY_URI: '/api/currencies',
    COUNTRY_HOLIDAYS_URI: '/api/country_holidays',
    COUNTRY_HOLIDAYS_SYNCHRONIZE_URI: '/api/country-holidays/synchronize',
    USERS_URI: '/api/users',
    CONFIGURATION_URI: '/api/configurations',
    VESSELS_DECKS_URI: '/api/vessels/:id/decks',
    VESSELS_FUEL_URI: '/api/vessels/:id/fuels',
    BOOKING_URI: '/api/bookings',
    BOOKING_ITEMS_URI: '/api/bookings/:id/items',
    BOOKING_EXPORT_URI: '/api/bookings-export',
    BOOKING_IMPORT_URI: '/api/bookings/import',
    BOOKING_IMPORT_TEMPLATE_URI: '/api/bookings/import-template',
    BOOKING_ATTACHMENTS_URI: '/api/bookings/:id/attachments',
    BOOKING_ATTACHMENTS_DOWNLOAD_URI: '/api/booking_attachments/:id/download',
    CARGO_TYPES_URI: '/api/cargo_types',
    PORT_CALL_PDA_URI: '/api/port-calls/:id/pda',
    PORT_CALL_PDAS_URI: '/api/port-call-pdas',
    PORT_CALL_PDA_LINES_URI: '/api/port-call-pda-lines',
    AUDIT_LOG_URI: '/api/audit-logs',
    CHANGE_PASSWORD: '/api/me/change-password',
    FORGOT_PASSWORD: '/api/auth/password/forgot',
    RESET_PASSWORD: '/api/auth/password/reset',
  },
  STATES: {
    LOGIN: '/auth/login',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    AUTHENTICATED: '/app/home',
  },
};
